var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGpsAlertType(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4776_220204)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0.75C5.79 0.75 0.75 5.79 0.75 12C0.75 18.21 5.79 23.25 12 23.25C18.21 23.25 23.25 18.21 23.25 12C23.25 5.79 18.21 0.75 12 0.75ZM12 18.75C11.175 18.75 10.5 18.075 10.5 17.25C10.5 16.425 11.175 15.75 12 15.75C12.825 15.75 13.5 16.425 13.5 17.25C13.5 18.075 12.825 18.75 12 18.75ZM13.7175 7.1175L13.215 13.1325C13.1625 13.7625 12.6375 14.25 12 14.25C11.3625 14.25 10.8375 13.7625 10.785 13.1325L10.2825 7.1175C10.2 6.1125 10.9875 5.25 12 5.25C12.96 5.25 13.725 6.03 13.725 6.975C13.725 7.02 13.725 7.0725 13.7175 7.1175V7.1175Z",
    fill: "#FF32AD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4.5,
    width: 15,
    height: 15,
    fill: "#FF32AD"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4776_220204)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 5.25C9.23971 5.25 6.9375 7.3885 6.9375 10.1189C6.9375 11.1577 7.26205 12.084 7.88492 12.952L11.6126 18.5462C11.7934 18.8182 12.2069 18.8177 12.3874 18.5462L16.1312 12.9329C16.7407 12.1043 17.0625 11.1313 17.0625 10.1189C17.0625 7.43421 14.7915 5.25 12 5.25ZM12 12.3321C10.7312 12.3321 9.69886 11.3392 9.69886 10.1189C9.69886 8.89867 10.7312 7.90579 12 7.90579C13.2688 7.90579 14.3011 8.89867 14.3011 10.1189C14.3011 11.3392 13.2688 12.3321 12 12.3321Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4776_220204"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4776_220204"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.5,
    height: 13.5,
    fill: "white",
    transform: "translate(5.25 5.25)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGpsAlertType);
export default __webpack_public_path__ + "static/media/gps_alert_type.c72d0d70.svg";
export { ForwardRef as ReactComponent };